import React, { createContext, useContext } from 'react';

import type {
  TreatmentWithConfig,
  TreatmentsWithConfig,
} from '@splitsoftware/splitio/types/splitio';

type FeatureFlagProviderProps = {
  treatments: TreatmentsWithConfig;
  children: React.ReactNode;
};

const FeatureFlagContext = createContext({
  treatments: {} as TreatmentsWithConfig,
});

/**
 * Returns the active treatment for a specific feature flag.
 */
export const useFeatureFlag = (featureName: string): TreatmentWithConfig => {
  const context = useContext(FeatureFlagContext);
  return context.treatments[featureName];
};

/**
 * Provider to access treatments within child components.
 */
export const FeatureFlagProvider = ({
  treatments,
  children,
}: FeatureFlagProviderProps) => {
  return children ? (
    <FeatureFlagContext.Provider
      value={{
        treatments,
      }}
    >
      {children}
    </FeatureFlagContext.Provider>
  ) : null;
};
